import { RotatingBadge } from "@/components/shared/SVGShapes";
import { TagDesign } from "@/components/shared/TagDesign";
import { TagCode } from "@/components/shared/TagCode";
import { TagLettering } from "@/components/shared/TagLettering";

/**
 * Hero section — Figma-spec brand redesign.
 * Typography: Bricolage Grotesque Medium (500) with rgba opacity hierarchy.
 * Decorative: Figma riso-PNG spark stars + SVG sticker badges.
 */
export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16">

      {/* ── Figma spark stars ── */}
      <img src="/stickers/spark-1.svg" alt="" aria-hidden="true"
        className="spark-float absolute pointer-events-none select-none w-[22px] h-[22px]"
        style={{ top: "28%", left: "23%", animationDelay: "0s" }} />
      <img src="/stickers/spark-2.svg" alt="" aria-hidden="true"
        className="spark-float absolute pointer-events-none select-none w-[16px] h-[16px]"
        style={{ top: "48%", left: "55%", animationDelay: "1.2s" }} />
      <img src="/stickers/spark-3.svg" alt="" aria-hidden="true"
        className="spark-float absolute pointer-events-none select-none w-[18px] h-[18px]"
        style={{ bottom: "22%", right: "14%", animationDelay: "0.6s" }} />
      <img src="/stickers/spark-4.svg" alt="" aria-hidden="true"
        className="spark-float absolute pointer-events-none select-none w-[14px] h-[14px]"
        style={{ bottom: "14%", left: "48%", animationDelay: "2s" }} />

      {/* ── Sticker badges — hidden on mobile, inline SVG for crisp vector rendering ── */}
      <TagDesign
        className="hidden md:block pointer-events-none select-none w-[148px]"
        style={{ position: "absolute", top: "10%", left: "62%", transform: "rotate(10deg)" }}
      />
      <TagCode
        className="hidden md:block pointer-events-none select-none w-[148px]"
        style={{ position: "absolute", top: "34%", left: "18%", transform: "rotate(-10deg)" }}
      />
      <TagLettering
        className="hidden md:block pointer-events-none select-none w-[148px]"
        style={{ position: "absolute", top: "calc(28% + 32px)", left: "64%", transform: "rotate(8deg)" }}
      />

      {/* ── Main content ── */}
      <div className="relative max-w-4xl mx-auto px-6 w-full flex flex-col items-center text-center">

        {/* Heading — Figma spec: Medium weight, rgba opacity hierarchy */}
        <h1
          className="font-[Bricolage_Grotesque] font-medium leading-[1.1] tracking-tight"
          style={{ fontSize: "clamp(2.8rem,6vw,5.5rem)" }}
        >
          {/* Line 1: 80% opacity */}
          <div style={{ color: "rgba(31,6,25,0.8)" }}>I'm Verónica</div>
          {/* Line 2: 60% opacity — slightly larger in Figma */}
          <div style={{ color: "rgba(31,6,25,0.6)" }}>Product Designer</div>
          {/* Line 3: 20% opacity — ghost text */}
          <div style={{ color: "rgba(31,6,25,0.2)" }}>& Builder</div>
        </h1>

        {/* CTAs — Figma spec colors */}
        <div className="flex flex-wrap gap-3 justify-center mt-10">
          <a
            href="#work"
            className="px-7 py-3 rounded-full font-semibold font-[Bricolage_Grotesque] transition-colors"
            style={{ backgroundColor: "#2640DE", color: "#F6E8E6" }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#1D30BB")}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#2640DE")}
          >
            See my work
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="inline-block ml-2 align-middle"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
          </a>
          <a
            href="#cv"
            className="px-7 py-3 rounded-full border border-black font-semibold font-[Bricolage_Grotesque] hover:border-[#2640DE] hover:text-[#2640DE] transition-colors"
            style={{ color: "#19154A" }}
          >
            View Resume
          </a>
        </div>

        {/* Rotating "designed and built by me" badge */}
        <RotatingBadge className="w-[130px] h-[152px] mt-10" />
      </div>
    </section>
  );
}
